import { useState, useEffect } from "react";

const ENTRY_POOL = [
  { name: "Sarah M.", method: "Instagram Follow", tag: "+1", color: "#0d9488", avatar: "SM" },
  { name: "Jake T.", method: "Email Signup", tag: "+1", color: "#f97316", avatar: "JT" },
  { name: "Priya K.", method: "Referral Bonus", tag: "+5", color: "#6366f1", avatar: "PK" },
  { name: "Carlos R.", method: "Visit Website", tag: "+1", color: "#ec4899", avatar: "CR" },
  { name: "Emma L.", method: "Instagram Follow", tag: "+1", color: "#14b8a6", avatar: "EL" },
  { name: "Noah W.", method: "Refer a Friend", tag: "+5", color: "#f59e0b", avatar: "NW" },
];

export default function EntriesRollingIn(): JSX.Element {
  const [items, setItems] = useState(ENTRY_POOL.slice(0, 2).map((e, i) => ({ ...e, key: i, fresh: false })));
  const [total, setTotal] = useState(248);
  const [poolIndex, setPoolIndex] = useState<number>(3);

  useEffect(() => {
    const interval = setInterval(() => {
      const next = ENTRY_POOL[poolIndex % ENTRY_POOL.length];
      const newItem = { ...next, key: Date.now(), fresh: true };
      setItems(prev => [newItem, ...prev.slice(0, 1)]);
      setTotal(t => t + (next.tag === "+5" ? 5 : 1));
      setPoolIndex(i => i + 1);
      setTimeout(() => {
        setItems(prev => prev.map(i => i.key === newItem.key ? { ...i, fresh: false } : i));
      }, 700);
    }, 1800);
    return () => clearInterval(interval);
  }, [poolIndex]);

  return (
    <div style={{
      width: "100%", maxWidth: 400, height: "auto", minHeight: 200, aspectRatio: "3/2", overflow: "hidden",
      background: "#fff", borderRadius: 14,
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: "flex", flexDirection: "column",
    }}>
      {/* Header */}
      <div style={{
        background: "#f8fafc", borderBottom: "1px solid #e2e8f0",
        padding: "10px 14px", display: "flex",
        alignItems: "center", justifyContent: "space-between",
        flexShrink: 0,
      }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>
          ⚡ Live Entries
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 800, color: "#0d9488" }}>
            {total.toLocaleString()}
          </span>
          <span style={{ fontSize: 10, color: "#94a3b8" }}>total entries</span>
          <span style={{
            fontSize: 10, fontWeight: 600, color: "#22c55e",
            background: "rgba(34,197,94,0.08)",
            padding: "2px 8px", borderRadius: 20,
            display: "flex", alignItems: "center", gap: 4,
          }}>
            <span style={{ fontSize: 7 }}>●</span> Live
          </span>
        </div>
      </div>

      {/* Entry rows */}
      <div style={{ flex: 1, overflow: "hidden" }}>
        {items.map((item, i) => (
          <div key={item.key} style={{
            display: "flex", alignItems: "center", gap: 10,
            padding: "14px 14px",
            borderBottom: i < items.length - 1 ? "1px solid #f8fafc" : "none",
            background: item.fresh ? "rgba(13,148,136,0.04)" : "#fff",
            transition: "background 0.5s ease",
            animation: i === 0 ? "entrySlide 0.35s cubic-bezier(0.34,1.56,0.64,1)" : "none",
            opacity: 1 - i * 0.2,
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: "50%",
              background: item.color, flexShrink: 0,
              display: "flex", alignItems: "center",
              justifyContent: "center",
              fontSize: 11, fontWeight: 800, color: "#fff",
            }}>{item.avatar}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>
                {item.name}
              </div>
              <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 1 }}>
                {item.method}
              </div>
            </div>
            <div style={{
              fontSize: 12, fontWeight: 800,
              color: item.tag === "+5" ? "#f97316" : "#0d9488",
              background: item.tag === "+5"
                ? "rgba(249,115,22,0.08)" : "rgba(13,148,136,0.08)",
              border: `1px solid ${item.tag === "+5"
                ? "rgba(249,115,22,0.2)" : "rgba(13,148,136,0.2)"}`,
              padding: "3px 8px", borderRadius: 20, flexShrink: 0,
            }}>{item.tag}</div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes entrySlide {
          from { opacity:0; transform:translateY(-8px); }
          to { opacity:1; transform:translateY(0); }
        }
      `}</style>
    </div>
  );
}
